export default __webpack_public_path__ + "static/media/link.2f5f48d9.svg";